import SwipeCard from './SwipeCard';

export default SwipeCard;
